// Versioning.Version — per-entity logical version.
//
// Stays at `v1` for every entity in MVP. Post-MVP, promotion rules
// (branch, merge, rebase) live in the Versioning BC proper.
export { from, mk, to, v1 };
import { Result } from "@bilda/utils";
import * as IdError from "../idError.js";
const mk = (n) => n;
const to = (n) => Number.isInteger(n) && n >= 1
    ? Result.ok(mk(n))
    : Result.err(IdError.mkMalformed("Version", String(n)));
const from = (v) => v;
// Canonical sentinel — every entity in MVP stamps at v1.
const v1 = mk(1);
//# sourceMappingURL=version.js.map